module.exports = __webpack_public_path__ + "img/63plus_logo.29d1608b.png";